import styled, { css, useTheme } from "styled-components";
import Radio from "common/Radio/Radio";
import { hexToRGB } from "@shared/utils/misc";
import Space from "antd/es/space";
import Text from "common/Typography/Text";
import React, { CSSProperties } from "react";

interface StyledRadioGroupProps {
  value?: number;
  options: { value: any; title: string; subText?: string }[];
  onChange: (value: any) => void;
  style?: CSSProperties;
  textStyle?: CSSProperties;
  size?: number;
}

const StyledRadioGroup = ({
  value,
  options,
  onChange,
  style,
  textStyle,
  size = 24,
}: StyledRadioGroupProps) => {
  const { isNewLook } = useTheme();
  return (
    <RadioGroup
      onChange={(e) => onChange(e.target.value)}
      style={style}
      value={value}
    >
      <Space
        orientation="vertical"
        size={isNewLook ? 8 : 12}
        style={{ width: "100%" }}
      >
        {options.map((option, index) => {
          return (
            <Radio
              value={option.value}
              key={index}
              style={{ alignItems: "center" }}
              $size={isNewLook ? Math.min(size, 18) : size}
            >
              <div style={{ marginLeft: 4 }}>
                <Text style={textStyle}>{option.title}</Text>
                <Text type="secondary">{option.subText}</Text>
              </div>
            </Radio>
          );
        })}
      </Space>
    </RadioGroup>
  );
};

export default StyledRadioGroup;

const RadioGroup = styled(Radio.Group)`
  width: 100%;
  .ant-radio-wrapper {
    padding: 8px 16px;
    border-radius: 8px;
    width: 100%;
    transition: background-color 0.35s;
  }
  .ant-radio-wrapper-checked {
    background-color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.06)};
  }
  ${(p) =>
    p.theme.isNewLook &&
    css`
      .ant-radio-wrapper {
        padding: 12px 14px;
        border-radius: ${p.theme.radii.control + 2}px;
        border: 1px solid ${p.theme.colors.lightBorderGrey};
        transition: border-color 150ms, background-color 150ms;
        &:hover {
          border-color: ${p.theme.colors.mediumBorderGrey};
        }
        .ant-typography + .ant-typography {
          display: block;
          font-size: 12.5px;
        }
      }
      .ant-radio-wrapper-checked,
      .ant-radio-wrapper-checked:hover {
        border-color: ${p.theme.colors.primaryBlue};
        background-color: ${hexToRGB(p.theme.colors.primaryBlue, 0.04)};
      }
    `}
`;
